import React from 'react'
import autobind from 'react-autobind'
import { Formik, Field } from 'formik'
import { TextField } from 'material-ui'
import Checkbox from 'material-ui/Checkbox'

const options = [{
  label: 'Effective Order Date',
  name: 'effectiveOrderDate',
  disabled: true
}, {
  label: 'Preferred Shipping Date',
  name: 'preferredShipDate',
  disabled: true
}, {
  label: 'Target Delivery Date',
  name: 'targetDeliveryDate',
  disabled: true
}, {
  label: 'Priority',
  name: 'priority',
  disabled: true
}, {
  label: 'Order Type',
  name: 'orderType',
  disabled: true
}, {
  label: 'Reason Code',
  name: 'reasonCode',
  disabled: true
}, {
  label: 'Shipping Box Size',
  name: 'shipBoxSize',
  disabled: true
}, {
  label: 'Shipping Weight',
  name: 'shippingWeight',
  disabled: true
}, {
  label: 'Shipper Account',
  name: 'shipperAccount',
  disabled: true
}, {
  label: 'Shipping Service Code',
  name: 'shipServiceCode',
  disabled: true
}, {
  label: 'Sage Bin Size',
  name: 'sageBinSize',
  disabled: true
}]

class Processing extends React.Component {
  constructor(props) {
    super(props)
    autobind(this)
  }
  handleProcessingError(error, styles) {
    if(Array.isArray(error)) {
      return (
        (<h3 style={styles.h3}>Error:
        {error.map((e, i) => {
          return (
            <div key={i} style={styles.resultSpan}>
            <p>{e.message}</p>
            </div>
          )
        })}
        </h3>)
      )
    } else if(error.hasOwnProperty('message')) {
      return (
        (<h3 style={styles.h3}>Error:
            <div style={styles.resultSpan}>
            <p>{error.message}</p>
            </div>
        </h3>)
      )
    } else {
      return (
        (<h3 style={styles.h3}>Error:
            <div style={styles.resultSpan}>
            <p>{error}</p>
            </div>
        </h3>)
      )
    }
  }
  render() {
    const { processing, effectiveOrderDate, orderType, preferredShipDate, priority, reasonCode,
      shipBoxSize, shipServiceCode, shipperAccount, shippingWeight, targetDeliveryDate, autoShip, sageBinSize } = this.props.order
    const styles = {
      h3: {
        fontSize: '20px',
        marginTop: '10px',
        lineHeight: '30px',
        marginRight: '30px',
      },
      itemDiv: {
        lineHeight: '20px',
        marginLeft: '10px',
      },
      subItemDiv: {
        lineHeight: '20px',
        marginLeft: '20px',
      },
      resultSpan: {
        marginLeft: '5px',
        display: 'inline',
        verticalAlign: 'bottom',
      },
      resultSpanError: {
        marginLeft: '5px',
        display: 'inline',
        verticalAlign: 'bottom',
        color: 'red',
      },
    };
    const initialValues = {
      effectiveOrderDate: effectiveOrderDate || '',
      preferredShipDate: preferredShipDate || '',
      targetDeliveryDate: targetDeliveryDate || '',
      priority: priority || '',
      orderType: orderType || '',
      reasonCode: reasonCode || '',
      shipBoxSize: shipBoxSize || '',
      shippingWeight: shippingWeight || '',
      shipperAccount: shipperAccount || '',
      shipServiceCode: shipServiceCode || '',
      sageBinSize: sageBinSize || '',
    }
    return (
      <div>
        <h2>Processing</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            render={(props) => (
              <div className="row">
                {options.map(({ label, name, disabled }) => (
                  <div className="col-md-6 col-lg-4">
                    <Field name={name}>
                      {({ field }) => (
                        <div>
                          <TextField
                            {...field}
                            floatingLabelText={label}
                            floatingLabelStyle={this.props.styles.floatingLabelStyle}
                            floatingLabelFixed={true}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </Field>
                  </div>
                ))}
              </div>
            )}
          />
          <br />
          <Checkbox
            label="Auto Ship"
            defaultChecked={autoShip}
            name="autoShip"
            disabled
          /><br />
          <h3 style={styles.h3}>Status:
            <div
              style={this.props.order.processing.error ? styles.resultSpanError : styles.resultSpan}
            >
              {this.props.order.processing.status}
            </div>
          </h3>
          {this.props.order.processing.error
            ? this.handleProcessingError(this.props.order.processing.error, styles)
            : null}
          <details>
            <summary>More Details</summary>
            <br />
            <h3 style={styles.h3}>Image Generation</h3>
            <div>
              Status: <div style={processing.image.status !== 'success' ? styles.resultSpanError : styles.resultSpan}>
                {processing.image.status}
              </div>
            </div>
            {_.map(processing.image.images, (image, i) => {
              var imageUrl = image.imageUrl
              if (image.imageUrl.hasOwnProperty('Location')) imageUrl = image.imageUrl.Location
              if (image.imageUrl.hasOwnProperty('Payload')) imageUrl = image.imageUrl.Payload
              return (
                <div key={i}>
                  <div style={styles.subItemDiv}>Image: <div style={styles.resultSpan}>{i + 1}</div></div>
                  <div style={styles.subItemDiv}>
                    Line Item(s): <div style={styles.resultSpan}>{image.lineItems || image.itemId}</div>
                  </div>
                  <div style={styles.subItemDiv}>Status:
                    <div style={image.status !== 'success' ? styles.resultSpanError : styles.resultSpan}>{image.status}</div>
                  </div>
                  <div style={styles.subItemDiv}>
                    Created at: <div style={styles.resultSpan}>{new Date(image.dateTime).toLocaleString()}</div>
                  </div>
                  <div style={styles.subItemDiv}>
                    Image Url: <div style={styles.resultSpan}>{imageUrl}</div>
                  </div>
                </div>
              )
            }
            )}
            <br />
            <h3 style={styles.h3}>PDF Generation</h3>
            <div>
              Status: <div style={processing.pdf.status !== 'success' ? styles.resultSpanError : styles.resultSpan}>
                {processing.pdf.status}
              </div>
            </div>
            {_.map(processing.pdf.pdfs, (pdf, i) =>
              (
                <div key={i}>
                  <div style={styles.subItemDiv}>PDF: <div style={styles.resultSpan}>{i + 1}</div></div>
                  <div style={styles.subItemDiv}>
                    Line Item(s): <div style={styles.resultSpan}>{pdf.lineItems}</div>
                  </div>
                  <div style={styles.subItemDiv}>Status:
                    <div style={pdf.status !== 'success' ? styles.resultSpanError : styles.resultSpan}>
                      {pdf.status}
                    </div>
                  </div>
                  <div style={styles.subItemDiv}>
                    Created at: <div style={styles.resultSpan}>{new Date(pdf.dateTime).toLocaleString()}</div>
                  </div>
                  <div style={styles.subItemDiv}>
                    Image Url: <div style={styles.resultSpan}>{pdf.pdfUrl}</div>
                  </div>
                </div>
              )
            )}
            <br />
            <h3 style={styles.h3}>Fulfillment</h3>
            <div style={styles.itemDiv}>
              Send to Fulfillment Server:
              <div
                style={processing.fulfillment.status !== 'sent' ? styles.resultSpanError : styles.resultSpan}
              >
                {processing.fulfillment.status}
              </div>
            </div>
          </details>
        </div>
      </div>
    )
  }
}

export default Processing


// WEBPACK FOOTER //
// ./src/components/orders/Common/Processing.js